import React, { useEffect, useState } from 'react'
// import './dashboard.css'
import './adminpanel.css'
import { useAuthContext } from '../../Hooks/useAuthContext'
import axios from 'axios'
import { FaAlignLeft, FaSignOutAlt, FaTimes, FaUserAlt } from 'react-icons/fa'
import { toast } from 'wc-toast'
import AdminConfirm from './AdminConfirm'
import { Link, useNavigate } from 'react-router-dom'
import AdminSidebar from './AdminSideBar'
import Invoice from '../../Component/Invoice/Invoice'

function DepositRequest() {
  const navigate                              = useNavigate()
  const { user, dispatch }                    = useAuthContext()
  const [sidemenu, setSideMenu]               = useState(false)
  const [shouldMenuSlide, setShouldMenuSlide] = useState(false)
  const [dashUser, setDashUser]               = useState(false)
  const [data, setData]                       = useState([])
  const [btnState, setBtnState]               = useState('Change Deposit Status')
  const [edit, setEdit]                       = useState(false)
  const [depositId, setDepositId]             = useState(null)
  const [confirm, setConfirm]                 = useState(false)
  const [updateData, setUpdateData]           = useState(null)
  const [printInvoice, setPrintInvoice]       = useState(false)
  const [invoiceData, setInvoiceData]         = useState(null)
  const [formData, setFormData]               = useState({ status: '' })

  /* Auth guard */
  useEffect(() => {
    axios.get(`${process.env.REACT_APP_BACKEND_URL}/admin/isadmin`, {
      headers: { Authorization: `Bearer ${user.token}` },
    }).then(r => {
      if (r.data.admin)     { /* ok */ }
      else if (r.data.user) navigate('/admin-panel')
      else                  navigate('/')
    }).catch(e => console.log(e))
  }, [user.token])

  /* Fetch deposits */
  useEffect(() => {
    axios.get(`${process.env.REACT_APP_BACKEND_URL}/admin/deposits`, {
      headers: { Authorization: `Bearer ${user.token}` },
    }).then(r => setData(r.data)).catch(e => console.log(e))
  }, [user.token, updateData])

  const logout = () => {
    dispatch({ type: 'LOGOUT', payload: null })
    setTimeout(() => navigate('/rf-admin'), 3000)
  }

  const handleChange    = (e) => setFormData(p => ({ ...p, [e.target.id]: e.target.value }))
  const handleEditClick = (id) => { setDepositId(id); setEdit(true) }
  const handleDelete    = (id) => { setDepositId(id); setConfirm(true) }
  const handleInvoice   = (d)  => { setInvoiceData(d); setPrintInvoice(true) }
  const onCancel        = ()   => setConfirm(false)

  const onConfirm = () => {
    axios.delete(`${process.env.REACT_APP_BACKEND_URL}/admin/delete-deposit/${depositId}`, {
      headers: { Authorization: `Bearer ${user.token}` },
    }).then(r => {
      toast.success('Deleted Successfully')
      setConfirm(false)
      setUpdateData(r.data)
    }).catch(e => console.log(e))
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    setBtnState('Processing...')
    axios.post(`${process.env.REACT_APP_BACKEND_URL}/admin/deposit/${depositId}`,
      { action: formData.status },
      { headers: { Authorization: `Bearer ${user.token}` } }
    ).then(r => {
      setBtnState('Change Deposit Status')
      toast.success('Status Updated Successfully')
      setUpdateData(r.data)
      setEdit(false)
    }).catch(e => {
      toast.error(e.response.data)
      setBtnState('Change Deposit Status')
    })
  }

  return (
    <div className="admin dashboard">

      {/* ── Header ──────────────────────────────────────── */}
      <div className="dashboard-header">
        <div className="rights-side">
          <Link to="/" style={{ textDecoration: 'none' }}>
            <p>{process.env.REACT_APP_APP_NAME}<span className="admin-badge">Admin</span></p>
          </Link>
          <FaAlignLeft size={18} onClick={() => { setShouldMenuSlide(true); setSideMenu(!sidemenu) }} />
        </div>
        <div className="left-side">
          <div className="dh-avatar" onClick={() => setDashUser(p => !p)}><FaUserAlt size={14} /></div>
          {dashUser && (
            <div className="user-menu">
              <p className="logout" onClick={logout}><FaSignOutAlt size={13} /> Logout</p>
            </div>
          )}
        </div>
      </div>

      {/* ── Sidebar ─────────────────────────────────────── */}
      {sidemenu && <AdminSidebar shouldMenuSlide={shouldMenuSlide} onClose={() => setSideMenu(false)} />}

      {/* ── Body ─────────────────────────────────────────── */}
      <div className="dashboard-main-section">
        <div className="loan-container">
          <div className="table-head">
            <div>
              <div className="db-breadcrumb">Admin &nbsp;/&nbsp; <span>Deposits</span></div>
              <h2>Deposit Requests</h2>
            </div>
          </div>

          <div className="db-card">
            <div className="db-card__bar" />
            <div className="loan-table">
              <table className="equal-table">
                <thead>
                  <tr>
                    <th>User Email</th>
                    <th>Amount</th>
                    <th>Method</th>
                    <th>Status</th>
                    <th>Note</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {data.length > 0 ? data.map(d => (
                    <tr key={d._id}>
                      <td>{d.userEmail}</td>
                      <td>{d.amount} {d.currency}</td>
                      <td>{d.method}</td>
                      <td>
                        <span className={`db-badge db-badge--${d.status === 'Successful' ? 'success' : d.status === 'Failed' ? 'danger' : 'warning'}`}>
                          {d.status}
                        </span>
                      </td>
                      <td>{d.note || '—'}</td>
                      <td>
                        <div className="action-tb">
                          <button className="db-btn db-btn--ghost db-btn--sm" onClick={() => handleEditClick(d._id)}>Edit</button>
                          <button className="db-btn db-btn--ghost db-btn--sm" onClick={() => handleInvoice(d)}>Invoice</button>
                          <button className="db-btn db-btn--danger db-btn--sm" onClick={() => handleDelete(d._id)}>Delete</button>
                        </div>
                      </td>
                    </tr>
                  )) : (
                    <tr><td colSpan="6" className="no-loan-message">No Deposit Requests</td></tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      {/* ── Edit overlay ─────────────────────────────────── */}
      {edit && (
        <div className="deposits-form">
          <button className="wd-close" onClick={() => setEdit(false)} aria-label="Close"><FaTimes size={14} /></button>
          <div className="send-money-container" style={{ width: '100%', maxWidth: '480px' }}>
            <form className="send-money-form" onSubmit={handleSubmit}>
              <h2>Edit Deposit Status</h2>
              <div className="send-money-form-group">
                <label htmlFor="status">Status <span>*</span></label>
                <select id="status" value={formData.status} onChange={handleChange} required>
                  <option value="" disabled>Select One</option>
                  <option value="Successful">Successful</option>
                  <option value="Failed">Failed</option>
                </select>
              </div>
              <div style={{ padding: '0 2rem' }}>
                <button type="submit" className="send-money-send-btn" disabled={btnState === 'Processing...'}>
                  {btnState === 'Processing...' ? 'Processing…' : 'Update Status →'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {confirm && <AdminConfirm message="Are you sure you want to delete?" onConfirm={onConfirm} onCancel={onCancel} />}

      {/* ── Print invoice overlay ────────────────────────── */}
      {printInvoice && (
        <div className="print-invoice">
          <div className="cancel-invoice">
            <FaTimes onClick={() => setPrintInvoice(false)} />
          </div>
          <Invoice data={invoiceData} />
        </div>
      )}
    </div>
  )
}

export default DepositRequest